import {
  SHOP_PRODUCTS_ACTIVATECODE_PATH,
  SUCCESSFULLY_OPENED_PATH
} from '@constant'
import {
  isFlowerDessert,
  isHotelProperty,
  isNormal,
  isPureUltimate,
  isSiDaProperty,
  isStandard,
  isTelSaleCityMerchant
} from '@merchant-backend/util'
import {
  buyUltimate,
  cantUse,
  getProTitle,
  goPayment,
  HLJ_STATISTIC,
  isSiDaMember,
  isSiDaTeam,
  isSiYiTeam
} from '@util'
import { Button, Modal } from 'hljd'
import moment from 'moment'
import React, { Component } from 'react'
import { hashHistory } from 'react-router'
import Decoration from '../Decoration'
// import DataCenter from '../DataCenter'
import FixedFooter from '../FixedFooter'
import GetCustomer from '../GetCustomer'
import Marketing from '../Marketing'
import Wechat from '../Wechat'
import WhoUse from '../WhoUse'
import style from './index.module.less'

/**
 * 当前商家为标准版、旗舰版有此 tab
 */
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      protocol: {}
    }
  }

  statisticApp = key => e => {
    if (
      isSiDaProperty() &&
      (key == 'no_pro_chanel_detail_liteApp' ||
        key == 'no_pro_chanel_detail_77')
    ) {
      e.stopPropagation()
      e.preventDefault()
      cantUse()
      return
    }

    if (key) {
      HLJ_STATISTIC({
        element_tag: key
      })
    }
  }

  handleOpen = () => {
    const { purchaseData = {} } = this.props
    const { flagship = {}, standard_to_flagship = {} } = purchaseData
    const _isUltimate = isPureUltimate()
    const _isStandard = isStandard()
    // 花艺甜品改为立即咨询
    if (!isTelSaleCityMerchant() && isFlowerDessert()) {
      buyUltimate()
      return
    }
    if (_isStandard) {
      HLJ_STATISTIC({
        element_tag: 'standard_to_pro'
      })
    }
    if (_isStandard && standard_to_flagship.is_buy_standard_to_flagship == 0) {
      this.setState({
        visible: true,
        protocol: standard_to_flagship.protocol
      })
      return false
    }
    if (!_isUltimate && !_isStandard && flagship.is_buy_flagship == 0) {
      this.setState({
        visible: true,
        protocol: flagship.protocol
      })
      return false
    }
    this.gotoPayment()
  }

  gotoPayment = () => {
    const { flagship_price = {} } = this.props
    const title = `购买${getProTitle()}`

    this.setState({
      visible: false
    })

    let params = { title, fee: flagship_price.fee }
    // 基础版或旗舰版支持指定开通成功页面
    if (isNormal() || isPureUltimate()) {
      params = this.getBase64Params(params)
    }
    goPayment(params)
  }

  // base64 加密文件
  // 计算过期时间，当前过期时间 + 1 year
  getBase64Params = params => {
    const { detail } = this.props
    const proDate = moment(
      detail['pro_date'] ||
        detail['enjoy_date'] ||
        moment().format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    )
      .add(1, 'y')
      .format('YYYY-MM-DD')
    let param
    let returnUrl
    if (isSiDaTeam()) {
      param = window.btoa(
        JSON.stringify({
          proDate,
          type: 'team'
        })
      )
      returnUrl = SUCCESSFULLY_OPENED_PATH + `?param=${param}`
    } else if (isSiDaMember()) {
      param = window.btoa(
        JSON.stringify({
          proDate,
          type: 'member'
        })
      )
      returnUrl = SUCCESSFULLY_OPENED_PATH + `?param=${param}`
    }
    Object.assign(params, { return_url: returnUrl })
    return params
  }

  /**
   * 基础版显示立即开通
   * 标准版显示立即升级
   * 旗舰版显示立即续费
   */
  getFooterData = () => {
    let btnText = '立即开通'
    if (isStandard()) {
      btnText = '立即升级'
    }
    if (isPureUltimate()) {
      btnText = '立即续费'
    }
    // 非电销城市，花艺甜品
    if (!isTelSaleCityMerchant() && isFlowerDessert()) {
      btnText = '立即咨询'
    }
    return {
      btnText
    }
  }

  render() {
    const { protocol, visible } = this.state
    const { pay_money = {}, coupon = {}, personal_ultimate_num } = this.props
    const { flagship_price = {} } = pay_money
    const {
      pay_fee, // 支付金额
      fee
    } = flagship_price
    const { coupon_type, gift_day, money_value } = coupon
    const { btnText } = this.getFooterData()

    const siDaRender = () => {
      // 四大展示内容
      if (isSiDaProperty()) {
        // 四大成员展示内容
        if (isSiDaMember()) {
          return (
            <div className={style.sidaMemberStyle}>
              <img
                src={'https://qnm.hunliji.com/FhBJsmcxbdLWliHi8ttiYwnPfXig'}
                alt="商家服务"
              />
              <img
                src="https://qnm.hunliji.com/camel-6d654404-6e87-457b-bc08-a79deb8f0ef3.jpg"
                alt="1"
              />
              <img
                src="https://qnm.hunliji.com/FjMml0BI7u9hcvH36wz-CkX30_6y"
                alt="2"
              />
              <img
                src="https://qnm.hunliji.com/Fhqz3ft4Y0fDCB9qw528I9Ie4BkN"
                alt="3"
              />
              <img
                src="https://qnm.hunliji.com/Fh32ngn61ucQ-8ZNdJVGqLucBSPQ"
                alt="4"
              />
              <img
                src="https://qnm.hunliji.com/Fjzlv01Yj22vIT9z9JB9-vOMdLzM"
                alt="QA"
              />
            </div>
          )
        }
        if (isSiYiTeam()) {
          return (
            <div className={style.sandaStyle}>
              <img
                src="https://qnm.hunliji.com/camel-7e359576-886d-4f83-80e3-21a7795b9b61.jpeg"
                alt=""
              />
            </div>
          )
        }
        // 四大团队展示内容
        return (
          <div className={style.sandaStyle}>
            <img
              src="https://qnm.hunliji.com/FtUfVP0NXWQsLGWLKGqVHs7slXDX"
              alt=""
            />
          </div>
        )
      }
      // 非四大展示内容
      return (
        <>
          <Decoration forPro={true} />
          <Marketing forPro={true} />
          <GetCustomer forPro={true} />
          {!isHotelProperty() && <Wechat />}
          <WhoUse onClick={this.handleOpen} />
        </>
      )
    }

    return (
      <div className={style['pro-wrap']} style={{ marginTop: 0 }}>
        {siDaRender()}
        {fee && (
          <FixedFooter
            price={pay_fee}
            leftExtra={
              <>
                {isSiDaTeam() &&
                  !isSiYiTeam() &&
                  personal_ultimate_num && (
                    <span className="sub-price">
                      （赠送{personal_ultimate_num}份个人商家服务（付费））
                    </span>
                  )}
                {coupon_type &&
                  (coupon_type == 2 ? (
                    <span className="sub-price">多送{gift_day}天</span>
                  ) : (
                    <span className="sub-price">限时减 ￥{money_value}</span>
                  ))}
              </>
            }
            rightExtra={
              isSiDaMember() && (
                <div
                  className={style['activate-code']}
                  onClick={() => {
                    hashHistory.push(SHOP_PRODUCTS_ACTIVATECODE_PATH)
                  }}
                >
                  使用激活码
                </div>
              )
            }
            rightText={btnText}
            onClick={this.handleOpen}
            render={
              isSiDaMember() && (
                <div className={style.member_wrap}>
                  <img
                    src="https://qnm.hunliji.com/Fv4ok71LJKuhIarBcHcmGDU62KwV"
                    alt=""
                    width={960}
                  />
                  <div className={style.member_center}>
                    <div className={style.member_price_wrap}>
                      {coupon_type &&
                        (coupon_type == 2 ? (
                          <div className={style.member_coupon}>
                            <span>多送{gift_day}天</span>
                          </div>
                        ) : (
                          <div className={style.member_coupon}>
                            <span>限时减 ￥{money_value}</span>
                          </div>
                        ))}
                      <div className={style.member_price}>
                        优惠价<span className={style.member_num}>
                          {pay_fee}
                        </span>元/年
                      </div>
                    </div>
                    <div
                      className={style.member_coupon_btn}
                      onClick={() => {
                        hashHistory.push(SHOP_PRODUCTS_ACTIVATECODE_PATH)
                      }}
                    >
                      使用激活码
                    </div>
                    <div
                      className={style.member_open_btn}
                      onClick={this.handleOpen}
                    >
                      {btnText}
                    </div>
                  </div>
                </div>
              )
            }
          />
        )}
        <Modal
          title={protocol.protocol_title}
          visible={visible}
          onOk={this.gotoPayment}
          onCancel={() => this.setState({ visible: false })}
          okText="开通商家服务"
          keyboard={false}
          width={700}
          wrapClassName={style.versionBox}
          footer={[
            <Button type="primary" key="ok" onClick={this.gotoPayment}>
              我同意遵守协议并继续下单
            </Button>
          ]}
        >
          <div
            style={{
              maxHeight: '500px',
              overflow: 'hidden',
              overflowY: 'auto'
            }}
          >
            <div
              dangerouslySetInnerHTML={{ __html: protocol.protocol_content }}
            />
          </div>
        </Modal>
      </div>
    )
  }
}

export default Index
